import { placeCaretAfterAtomic } from '../atomicCaret';

/**
 * Replace a typed trigger ("/query" or "{{") with arbitrary inline HTML, in
 * place — DOM surgery so bold runs, links and earlier pills survive
 * byte-for-byte (generalized from replaceSlashWithMention).
 *
 * `textNode` is the text node the caret sat in when the picker opened;
 * `queryLength` is how much was typed after the trigger before the picker
 * took focus. Returns true when placed (caret ends up after the insert).
 */
export const replaceTriggerWithHtml = (el, textNode, trigger, queryLength, htmlStr) => {
  if (!textNode || textNode.nodeType !== Node.TEXT_NODE || !el.contains(textNode)) {
    return false;
  }

  const text = textNode.textContent;
  const triggerIndex = text.lastIndexOf(trigger);
  if (triggerIndex === -1) return false;
  const end = Math.min(triggerIndex + trigger.length + queryLength, text.length);

  const range = document.createRange();
  range.setStart(textNode, triggerIndex);
  range.setEnd(textNode, end);
  range.deleteContents();

  const fragment = range.createContextualFragment(htmlStr);
  const pill =
    fragment.querySelector?.('[data-doc-variable], [data-doc-math]') ||
    (fragment.firstChild?.nodeType === Node.ELEMENT_NODE &&
    (fragment.firstChild.hasAttribute?.('data-doc-variable') ||
      fragment.firstChild.hasAttribute?.('data-doc-math'))
      ? fragment.firstChild
      : null) ||
    fragment.firstChild;
  range.insertNode(fragment);

  // Keep scroll put — plain focus() scrolls the block to the top of the
  // nearest scroller, which jumps the page when inserting from the picker.
  el.focus({ preventScroll: true });
  // Prefer the pill itself, then park the caret in the trailing text buffer
  // (ZWSP / nbsp) so the next paste isn't flush against contenteditable=false.
  const pills = el.querySelectorAll('[data-doc-variable], [data-doc-math]');
  const caretHost =
    (pill && el.contains(pill) && pill) ||
    pills[pills.length - 1];
  if (caretHost) {
    placeCaretAfterAtomic(caretHost);
  }
  return true;
};
